module.exports = __webpack_public_path__ + "img/union3Img.d9c24946.png";